import type { EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForConfluenceBuyReverseTrialExperiment(
	context: EditionAwarenessContextType,
): boolean {
	const {
		product,
		edition,
		isInvoiceable,
		isInReverseTrial,
		isInTrial,
		isInPredunning,
		isInCollection,
		billingSourceSystem,
	} = context;

	return Boolean(
		!isInCollection &&
			product === 'confluence' &&
			edition === 'premium' &&
			(isInTrial || isInPredunning) &&
			isInReverseTrial &&
			isInvoiceable === false &&
			billingSourceSystem === 'CCP',
	);
}
